import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import history from '../../routes/history';
import CandidateSignupButton from '../../pages/PostAJob/EmployerProfile/components/CandidateBackNext/CandidateSignupButton';
import ProgressBar from '../ProgressBar/ProgressBar';
import { candidateDetailSuccess } from '../../redux/actions'; 
import './salary.css';
import errorIcon from '../../assets/img/ci_warning.png';

const CandidateSalary = () => {
  const dispatch = useDispatch();
  const getInputValues = useSelector((state) => state.candidateReducer.candidateDetails);

  const persistedState = JSON.parse(localStorage.getItem('persist:root'));
  const candidateDetails = persistedState?.candidateReducer
    ? JSON.parse(persistedState.candidateReducer).candidateDetails
    : null;

  const gigType = candidateDetails?.gigType || "";

  const [salary, setSalary] = useState(getInputValues?.pay || ""); 
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    setSalary(getInputValues?.pay || "");
  }, [getInputValues]);

  const backFunction = () => {
    history.push('/location');
  };

  const nextFunction = () => {
    if (!salary) {
      setShowError(true);
    } else {
      setShowError(false);
      dispatch(candidateDetailSuccess({ ...getInputValues, pay: salary })); 
      history.push('/date');
    }
  };

  const skipFunction = () => {
    history.push('/date');
  };

  return (
    <div className="profilecompleteion">
      <div>
        <ProgressBar heading={"Create candidate’s skill listing"} percent={70} />

        <div className="email-text">
          Desired pay
          <div className="email-mandatory">(Optional)</div>
        </div>
        <div className="mobile-mains">
          <div className="mobilesub">
            <div className={"currency-parent-container"}>
              <div className="currency-container">
                <div className="usd-container">
                  {gigType === 'Permanent' ? <span>Yearly</span> : <span>Hourly</span>}
                </div>
                <div className="dollar-sign">$</div>
                <input
                  className="input-screenscurrency"
                  type="number"
                  value={salary}
                  onChange={(e) => {
                    const newValue = e.target.value;
                    if (newValue === "" || Number(newValue) >= 0) {
                      setSalary(newValue);
                      setShowError(false);
                    }
                  }}
                  autoFocus={true}
                />
              </div>
            </div>

            {showError && (
              <div className="error-msg-content">
                <img src={errorIcon} alt="" />
                <span className="error-text">
                  Please enter your desired salary to continue
                </span>
              </div>
            )}
          </div>
        </div>
        <div style={{ paddingTop: "25%" }}>
          <CandidateSignupButton
            nextFunction={nextFunction}
            backFunction={backFunction}
            skipFunction={skipFunction}
          />
        </div>
      </div>
    </div>
  );
};

export default CandidateSalary;
